import PublicActivityType from '@/pages/publicPages/PublicActivityType/PublicActivityType';
import PublicActivityTypeSSP from '@/pages/publicPages/PublicActivityType/PublicActivityType.ssp';
import PageMetadata from '@/v2/domains/SEO/components/PageMetadata/PageMetadata';

export default function StoriesWithQuestions(props) {
  return (
    <>
      <PageMetadata title="Spanish Quiz for Kids | Rockalingua" />
      <PublicActivityType {...props.pageProps} />
    </>
  );
}

export const getServerSideProps = async (context) =>
  await PublicActivityTypeSSP({ context, activityType: 'songQuestions' });
